export default __webpack_public_path__ + "static/media/ib-logo.a613ce23.jpeg";